import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "open", "defaultOpen", "collapsedHeight", "onOpenCallback", "onCloseCallback", "className", "htmlProps"];
import { useEffect } from 'react';
import { useCollapse, useMountChildrenValidation } from '@crehana/react-hooks';
import parseClassnames from "../helpers/parseClassnames";
import { jsx as _jsx } from "react/jsx-runtime";
var Collapse = function Collapse(_ref) {
  var children = _ref.children,
    open = _ref.open,
    defaultOpen = _ref.defaultOpen,
    collapsedHeight = _ref.collapsedHeight,
    onOpenCallback = _ref.onOpenCallback,
    onCloseCallback = _ref.onCloseCallback,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    htmlProps = _ref.htmlProps,
    collapseProps = _objectWithoutProperties(_ref, _excluded);
  var _useCollapse = useCollapse({
      isOpen: open,
      defaultOpen: false,
      collapsedHeight: collapsedHeight || 0,
      onOpenCallback: onOpenCallback,
      onCloseCallback: onCloseCallback
    }),
    getCollapseProps = _useCollapse.getCollapseProps,
    toggleOpen = _useCollapse.toggleOpen;
  var shouldMountChildren = useMountChildrenValidation({
    isOpen: open
  });
  useEffect(function () {
    toggleOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getCollapseProps()), collapseProps), htmlProps), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: parseClassnames(className, 'flex items-center relative'),
      children: shouldMountChildren && children
    })
  }));
};
export default Collapse;